// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a AllergyIntolerance view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...AllergyIntoleranceRender }`, [AllergyIntoleranceRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const AllergyIntoleranceRenderFragment = graphql(`
  fragment AllergyIntoleranceRender on AllergyIntolerance @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    clinicalStatus {
      text
      coding {
        system
        code
        display
      }
    }
    verificationStatus {
      text
      coding {
        system
        code
        display
      }
    }
    type
    category
    criticality
    code {
      text
      coding {
        system
        code
        display
      }
    }
    patient {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    onsetDateTime
    onsetAge {
      value
      comparator
      unit
      system
      code
    }
    onsetPeriod {
      start
      end
    }
    onsetRange {
      low {
        value
        comparator
        unit
        system
        code
      }
      high {
        value
        comparator
        unit
        system
        code
      }
    }
    onsetString
    recordedDate
    recorder {
      reference
      type
      display
    }
    asserter {
      reference
      type
      display
    }
    lastOccurrence
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
    reaction {
      substance {
        text
        coding {
          system
          code
          display
        }
      }
      manifestation {
        text
        coding {
          system
          code
          display
        }
      }
      description
      onset
      severity
      exposureRoute {
        text
        coding {
          system
          code
          display
        }
      }
      note {
        authorReference {
          reference
          type
          display
        }
        authorString
        time
        text
      }
    }
  }
`);
